import Loadable from '../../components/loadable';

const EditContactStyle = Loadable({
  loader: () => import('react/pages/contacts/styles/edit_contact_style'),
});

angular.module('gym').value('EditContactStyle', EditContactStyle);
